import { render } from "./OverviewView.vue?vue&type=template&id=5a484c2a&scoped=true"
import script from "./OverviewView.vue?vue&type=script&lang=js"
export * from "./OverviewView.vue?vue&type=script&lang=js"

import "./OverviewView.vue?vue&type=style&index=0&id=5a484c2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a484c2a"]])

export default __exports__